var _style, _rect, _g, _g2, _path, _rect2, _path2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _defs, _g3, _path3, _path4, _defs2, _g4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicrosoftOutlook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{opacity:0.2;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{opacity:0.12;}\n\t.st4{fill:#123B6D;}\n\t.st5{fill:#0364B8;}\n\t.st6{fill:#0358A7;}\n\t.st7{fill:#0078D4;}\n\t.st8{fill:#28A8EA;}\n\t.st9{fill:#50D9FF;}\n\t.st10{fill:#14447D;}\n\t.st11{clip-path:url(#SVGID_2_);}\n\t.st12{opacity:0.35;}\n\t.st13{opacity:6.000000e-02;}\n\t.st14{fill:url(#Envelope-3_1_);}\n\t.st15{fill:url(#SVGID_3_);}\n\t.st16{clip-path:url(#SVGID_5_);}\n\t.st17{opacity:0.48;}\n\t.st18{opacity:0.24;}\n\t.st19{fill:#0F78D4;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0,
    className: "st0",
    width: 512,
    height: 512
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Outlook"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_142"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M483,256.2v185.4c0,12.8-10.3,23-23,23H155.2c-12.8,0-23-10.3-23-23V256.2l0,0c-0.2,3.6,1.8,6.8,5,8.5l0,0 l20.5,11.5V68.8c-0.5-11.3,8.1-20.9,19.4-21.4l0,0h260.5c11.2,0.5,19.8,10.3,19.4,21.4v207.4l20.7-11.5l0,0 C481,263,483,259.8,483,256.2z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M483,256.2v185.4c0,12.8-10.3,23-23,23H155.2c-12.8,0-23-10.3-23-23V256.2l0,0c-0.2,3.6,1.8,6.8,5,8.5l0,0 l20.5,11.5V68.8c-0.5-11.3,8.1-20.9,19.4-21.4l0,0h260.5c11.2,0.5,19.8,10.3,19.4,21.4v207.4l20.7-11.5l0,0 C481,263,483,259.8,483,256.2z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M483,256.2c0-3.4-1.8-6.7-4.9-8.5l0,0l-145.4-92.2l-1.4-0.9l0,0c-6.1-2.9-13.3-2.9-19.6,0l0,0l-2,1.4 l-158.2,92.2l0,0c-3.1,1.8-4.9,5-4.9,8.5c0,3.6,2,7,5,8.8l158.2,92.2l2,1.4l0,0c6.1,2.9,13.3,2.9,19.6,0l0,0l2-1.4l145.4-92.2 C481.9,263.2,483.3,259.8,483,256.2z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 158.4,
    y: 204.3,
    className: "st5",
    width: 103.9,
    height: 95.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M457.1,113.3V69.9c0.5-11.2-8.1-20.9-19.4-21.4H177.9c-11.3,0.5-20.2,10.1-19.6,21.4v43.4H457.1z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 158.4,
    y: 113.3,
    className: "st7",
    width: 103.9,
    height: 90.7
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 262.3,
    y: 113.3,
    className: "st8",
    width: 103.9,
    height: 90.7
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 366.2,
    y: 113.3,
    className: "st9",
    width: 90.7,
    height: 90.7
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 366.2,
    y: 204.3,
    className: "st8",
    width: 90.7,
    height: 95.2
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 262.3,
    y: 204.3,
    className: "st7",
    width: 103.9,
    height: 95.2
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 262.3,
    y: 299.6,
    className: "st5",
    width: 103.9,
    height: 95.2
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 158.4,
    y: 299.6,
    className: "st10",
    width: 103.9,
    height: 86.6
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 366.2,
    y: 299.6,
    className: "st7",
    width: 90.7,
    height: 95.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M483,256.2v185.4c0,12.8-10.3,23-23,23H155.2c-12.8,0-23-10.3-23-23V256.2l0,0 c-0.2,3.6,1.8,6.8,5,8.5l0,0l20.5,11.5V68.8c-0.5-11.3,8.1-20.9,19.4-21.4l0,0h260.5c11.2,0.5,19.8,10.3,19.4,21.4v207.4 l20.7-11.5l0,0C481,263,483,259.8,483,256.2z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Envelope",
    className: "st12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M477.9,264.6L477.9,264.6l-151.2,92.2l-2.3,1.4l0,0c-6.3,3.1-13.7,3.1-20,0l0,0l-2.3-1.4l-164-92.2 l0,0c-3.2-1.6-5.2-4.9-5-8.5l0,0v185.4c0,12.8,10.3,23,23,23h304.2c12.8,0,23-10.3,23-23V256.2 C483.3,259.8,481.2,263,477.9,264.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Envelope-2",
    className: "st13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M477.9,264.6L477.9,264.6l-151.2,92.2l-2.3,1.4l0,0c-6.3,3.1-13.7,3.1-20,0l0,0l-2.3-1.4l-164-92.2 l0,0c-3.2-1.6-5.2-4.9-5-8.5l0,0v185.4c0,12.8,10.3,23,23,23h304.2c12.8,0,23-10.3,23-23V256.2 C483.3,259.8,481.2,263,477.9,264.6z"
  })))))))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Envelope-3_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 428.1737,
    y1: -1315.9633,
    x2: 187.0184,
    y2: -1603.4834,
    gradientTransform: "matrix(1 0 0 -1 0 -1106)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#35B8F1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    style: {
      stopColor: "#0F78D1"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Envelope-3",
    className: "st14",
    d: "M477.9,264.6L477.9,264.6l-151.2,92.2l-2.3,1.4l0,0c-6.3,3.1-13.7,3.1-20,0l0,0l-2.3-1.4 l-164-92.2l0,0c-3.2-1.6-5.2-4.9-5-8.5l0,0v185.4c0,12.8,10.3,23,23,23h304.2c12.8,0,23-10.3,23-23V256.2 C483.3,259.8,481.2,263,477.9,264.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 303.3941,
    y1: -1362.2,
    x2: 303.3941,
    y2: -1569.7941,
    gradientTransform: "matrix(1 0 0 -1 0 -1106)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#35B8F1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#28A8EA"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M155,463.5h305.8c4.7,0,9.4-1.6,13.1-4.3L302.6,354.6l-2.3-1.4L139,258.9l0,0l-6.1-2.7v184.3 C132.5,452.9,142.4,463.2,155,463.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_4_",
    d: "M483,256.2v185.4c0,12.8-10.3,23-23,23H155.2c-12.8,0-23-10.3-23-23V256.2l0,0 c-0.2,3.6,1.8,6.8,5,8.5l0,0l20.5,11.5V68.8c-0.5-11.3,8.1-20.9,19.4-21.4l0,0h260.5c11.2,0.5,19.8,10.3,19.4,21.4v207.4 l20.7-11.5l0,0C481,263,483,259.8,483,256.2z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_5_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_4_",
    style: {
      overflow: "visible"
    }
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "st16"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ambient"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st17"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M48.3,139.4h194.4c10.8,0,19.6,8.8,19.6,19.6v194.4c0,10.8-8.8,19.6-19.6,19.6H48.3 c-10.8,0-19.6-8.8-19.6-19.6V159C28.7,148.2,37.5,139.4,48.3,139.4z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st18"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M48.3,139.4h194.4c10.8,0,19.6,8.8,19.6,19.6v194.4c0,10.8-8.8,19.6-19.6,19.6H48.3 c-10.8,0-19.6-8.8-19.6-19.6V159C28.7,148.2,37.5,139.4,48.3,139.4z"
  }))))))))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M48.3,139.4h194.4c10.8,0,19.6,8.8,19.6,19.6v194.4c0,10.8-8.8,19.6-19.6,19.6H48.3 c-10.8,0-19.6-8.8-19.6-19.6V159C28.7,148.2,37.5,139.4,48.3,139.4z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M92.7,224.1c4.3-9.5,11.7-17.6,20.7-23c10.3-5.9,21.8-8.8,33.7-8.3c10.8-0.2,21.2,2.5,30.6,7.9 c8.8,5.6,15.8,13.5,20.2,23c5,10.1,7.4,21.1,7.2,32.2c0.2,11.7-2.2,23.2-7.2,33.7c-4.7,9.5-12.1,17.5-20.9,23 c-9.5,5.4-20.5,8.3-31.5,7.9c-11,0.2-21.8-2.5-31.3-8.1c-8.8-5.2-15.8-12.8-20.5-22c-4.9-9.9-7.4-20.9-7.2-32 C85.5,246.8,87.9,234.9,92.7,224.1z M115.8,278.1c2.3,5.9,6.3,11.2,11.5,14.9c5.4,3.8,11.9,5.8,18.4,5.6 c6.8,0.2,13.7-1.6,19.4-5.6c5.2-4,9.2-9.2,11.5-15.3c2.3-6.8,3.6-14,3.4-21.2c0-7.2-1.1-14.4-3.2-21.2 c-2.2-6.1-5.9-11.7-11-15.7c-5.6-4.1-12.4-6.3-19.4-5.9c-6.7-0.2-13.1,1.8-18.7,5.6c-5.4,3.8-9.5,9.2-12.1,15.1 C110.2,248.4,110.2,264.1,115.8,278.1L115.8,278.1z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrosoftOutlook);
export default __webpack_public_path__ + "static/media/microsoft-outlook.672077c91ba74a2d12b03c4783bd23a7.svg";
export { ForwardRef as ReactComponent };